<template>
  <div>
    <el-table :height="height" :data="data" border ref="multipleTable"
      v-loading="loading" style="width: 100%" @selection-change="handleSelectionChange" stripe
      :row-key="(row) => row.guid">
      <el-table-column type="selection" :reserve-selection="true" width="40" header-align="center" align="center">
      </el-table-column>
      <el-table-column label="序号" width="60" header-align="center" align="center" fixed>
        <template slot-scope="scope">
          {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="customerName" width="200" label="药店名称" header-align="center" align="left"
        show-overflow-tooltip fixed>
        <template slot-scope="scope">
          {{ scope.row.customerName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="sourceGuid" width="96" label="是否底库建档" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.sourceGuid?'是':'否'  }}
        </template>
      </el-table-column>
      <el-table-column prop="terminalProperty" width="140" label="药店属性" show-overflow-tooltip header-align="center"
        align="left">
        <template slot-scope="scope">
          {{ scope.row.terminalProperty || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" width="96" label="创建人" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.createUserName  }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" header-align="center" width="180" align="left" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
      </el-table-column>
      <el-table-column prop="updateUserName" width="96" label="更新人" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.updateUserName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" header-align="center" width="180" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | getTimeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="approveVO" width="96" label="审核人" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.approveVO">{{ scope.row.approveVO.approveStaffName || '-' }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="approveVO" label="审核时间" header-align="center" width="180" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.approveVO">{{ scope.row.approveVO.approveTime | getTimeDate }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="approveVO" label="审核状态" header-align="center" width="96" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.approveVO&&scope.row.approveVO.approveState" :type="type[scope.row.approveVO.approveState]">{{
            approveStateObj[scope.row.approveVO.approveState] || '-'
          }}</el-tag>
          <span v-else>{{ '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="venue" width="110" label="省" show-overflow-tooltip header-align="center" align="left">
        <template slot-scope="scope">{{ scope.row.province | province }}</template>
      </el-table-column>
      <el-table-column prop="venue" width="110" label="市" show-overflow-tooltip header-align="center" align="left">
        <template slot-scope="scope">{{ scope.row.city | city }}</template>
      </el-table-column>
      <el-table-column prop="venue" width="130" label="区/县" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.district | district }}</template>
      </el-table-column>
      <el-table-column prop="address" label="详细地址" min-width="240" show-overflow-tooltip header-align="center"
        align="left">
        <template slot-scope="scope">
          {{ scope.row.address || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="contacts" width="110" label="药店联系人" show-overflow-tooltip header-align="center"
        align="left">
        <template slot-scope="scope">
          {{ scope.row.contacts || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="contactTel" width="120" label="药店联系电话" show-overflow-tooltip header-align="center"
        align="left">
        <template slot-scope="scope">
          {{ scope.row.contactTel || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" width="120" label="业务指派人员" header-align="center"  align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getbelongStaffsName(scope.row) }}
          </template>
        </el-table-column> 
      <el-table-column prop="mobileNo" width="120" label="指派人手机号" show-overflow-tooltip header-align="center"
        align="left">
        <template slot-scope="scope">
          {{ scope.row.mobileNo || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="customerCode" width="140" label="药店编码" show-overflow-tooltip header-align="center"
        align="left">
        <template slot-scope="scope">
          {{ scope.row.customerCode || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <a class="txt-color" @click="toDetail(scope.row)"> 详情 | </a>
          <a class="txt-color" v-if="!scope.row.approveVO||scope.row.approveVO.approveState=='A'"  @click="toAudit(scope.row)">审核</a>
          <a class="txt-color" v-if="scope.row.approveVO&&(scope.row.approveVO.approveState=='Y'||scope.row.approveVO.approveState=='N')" @click="toAudit(scope.row)">撤回重审</a>
          <a class="txt-color" v-if="scope.row.approveVO&&!!scope.row.approveVO.approveCount" @click="historyReviewRecords(scope.row, 'customer')"> | 查看历史审核 </a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import tableMixins from './mixins/tableMixins.js';
export default {
  mixins: [tableMixins],
  props: {
    height: { // 表格高度
      type: Number,
    },
    data: { // 表格数据
      type: Array,
      default: [],
    },
    loading: { // 表格数据
      type: Boolean,
      default: false,
    },
    page: { // 表格数据
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      
      
    };
  },
  created() {
    
    
  },
  beforeDestroy() {
    
  },
  methods: {
   
  },
};
</script>
